<template>
    <v-dialog fullscreen v-model="dialog" transition="slide-x-reverse-transition">
        <v-card tile>
            <v-card-title>
                <v-row no-gutters>
                    <v-col cols="1">
                        <v-btn icon @click="carouselBack">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="10" align="center">
                        <div class="app-title text-truncate">
                            {{ $t('exercises.create_exercise') }}
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <exercise-creator
                ref="creator"
                @success="onCreatorSuccess"
                :new-exercise="newEx"
                @cancel="hide"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import ExerciseCreator from "@/components/coach/routines/ExerciseCreator";
import {mapMutations, mapState} from "vuex";

export default {
    name: "ExerciseCreatorDialog",
    components: {ExerciseCreator},
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            newEx: null,
        }
    },
    computed: {
        ...mapState(['dialogActive','secondDialogActive'])
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setSecondDialogActive']),
        show(payload = null) {
            const vm = this
            if (payload) vm.newEx = payload
            vm.dialog = true
            if (vm.isSecondDialog) {
                vm.setSecondDialogActive(true)
            } else {
                vm.setDialogActive(true)
            }
        },
        hide() {
            const vm = this
            vm.newEx = null
            vm.dialog = false
            if (vm.isSecondDialog) {
                vm.setSecondDialogActive(false)
            } else {
                vm.setDialogActive(false)
            }
        },
        onCreatorSuccess(exercise) {
            const vm = this
            vm.$refs.creator.reset()
            vm.$emit('success', exercise)
            vm.hide()
        },
        carouselBack() {
            const vm = this
            vm.$refs.creator.goBack()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        }
    }
}
</script>

<style scoped>

</style>